module.exports = __webpack_public_path__ + "BFG1.8fa8525bd9f5183677fd.jpg";


//////////////////
// WEBPACK FOOTER
// E:/Angular/website-angular/src/assets/BFG1.jpg
// module id = ../../../../../src/assets/BFG1.jpg
// module chunks = main